//signup is createaccount

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import "./SignUp.css";
import PublicIcon from "@material-ui/icons/Public";
import ButtonPrimary from "../LoginAccount/ButtonPrimary";
import ButtonSecondary from "../LoginAccount/ButtonSecondary";
import { auth } from "../firebase";
import { login } from "../features/userSlice";

function SignUp() {
  //Hooks
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fName, setFName] = useState("");
  const [lName, setLName] = useState("");
  const dispatch = useDispatch();
  const history = useHistory();

  const signUp = (e) => {
    e.preventDefault();
    // checking if the user entered the requeriments

    if (!fName) {
      return alert("please enter a first name");
    }
    if (!lName) {
      return alert("please enter a last name");
    }
    if (!password) {
      return alert("please enter a password");
    }

    auth
      .createUserWithEmailAndPassword(email, password)
      .then((userAuth) => {
        //updateprofile will accept first name
        userAuth.user
          .updateProfile({
            displayName: fName,
          })
          .then(() => {
            dispatch(
              login({
                email: userAuth.user.email, // email is going to be equal to this
                uid: userAuth.user.uid, // uid is give by firebase
                displayName: fName,
              })
            );
            history.push("/teslaacount"); // pushing it to the tesla account after creating an account
          });
      }) // alerts if theres any erros
      .catch((error) => alert(error.message));
  };

  return (
    <div className="signup">
      <div className="signup__header">
        <div  className="signup__logo">
          <Link to='/'>
              {''}
            <img
              src="https://assets.website-files.com/5e8fceb1c9af5c3915ec97a0/5ec2f037975ed372da9f6286_Tesla-Logo-PNG-HD.png"
              alt=""
            />
          </Link>
        </div>
        {/* language */}
        <div className="signup__language">
          <PublicIcon /> <span>en-US</span>
        </div>
      </div>
      {/*  user to signup */}
      <div className="signup__info">
        <h1>Create Account</h1>
        {/*  user to enter the info */}
        <form className="signup__form">
          <label htmlfor="fName"> First Name</label>
          {/*  target gets what the user is typying and puts it in value email */}
          <input
            type="email"
            id="fName"
            value={fName}
            onChange={(e) => setFName(e.target.value)}
          />
          <label htmlfor="lName">Last Name</label>
          {/*  target gets what the user is typying and puts it in value email */}
          <input
            type="text"
            id="lName"
            value={lName}
            onChange={(e) => setLName(e.target.value)}
          />
          <label htmlFor="email">Email Address</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <label htmlfor="password"> Password</label>
          {/*  target gets what the user is typying and puts it in value password */}
          {/*  type is used to hide the password when the user enters it, it will show password  */}
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {/*  The user will submit his user name and password using this button*/}
          
          <ButtonPrimary name="create account" Type="submit" onClick={signUp}/>
          
        </form>
        <div className="signup__divider">
          <hr /> <span>OR</span>
          <hr />
        </div>
        {/*goes back to the login page*/}
        <Link to="/login">
          <ButtonSecondary name="sign in" className="signup__buttonSecondary" />
        </Link>
      </div>
    </div>
  );
}

export default SignUp;
